import { fetchPlanogram as fetchPlanogramHTTPRequest, savePlanogram as savePlanogramHTTPRequest, deletePlanogram as deletePlanogramHTTPRequest } from '../api';

export const PLANOGRAM_FETCHED = 'PLANOGRAM_FETCHED';
export const PLANOGRAM_FETCHING = 'PLANOGRAM_FETCHING';
export const PLANOGRAM_ERROR = 'PLANOGRAM_ERROR';
export const PLANOGRAM_SAVING = 'PLANOGRAM_SAVING';
export const PLANOGRAM_SAVED = 'PLANOGRAM_SAVED';
export const PLANOGRAM_DELETING = 'PLANOGRAM_DELETING';
export const PLANOGRAM_DELETED = 'PLANOGRAM_DELETED';

/**
 * fetch planogram for the given devicecode
 * @param {} deviceCode
 * @returns
 */
export const fetchPlanogram = deviceCode => {
    return (dispatch, getState) => {
        dispatch({ type: PLANOGRAM_FETCHING });
        const user = getState().user;
        return fetchPlanogramHTTPRequest(deviceCode, user.group.Id)
            .then(response => {
                dispatch({ type: PLANOGRAM_FETCHED, data: response || {} });
            })
            .catch(error => {
                dispatch({ type: PLANOGRAM_ERROR, error });
            });
    };
};

/**
 * save planogram data for the given deviceCode
 * @param {} deviceCode
 * @param {*} planogramData
 * @returns
 */
export const savePlanogram = (deviceCode, planogramData, overWrite) => {
    return (dispatch, getState) => {
        dispatch({ type: PLANOGRAM_SAVING });
        const user = getState().user;

        return savePlanogramHTTPRequest(deviceCode, user.group.Id, planogramData, overWrite)
            .then(response => dispatch({ type: PLANOGRAM_SAVED, data: planogramData }))
            .catch(error => dispatch({ type: PLANOGRAM_ERROR, error }));
    };
};

export const deletePlanogram = deviceCode => {
    return (dispatch, getState) => {
        dispatch({ type: PLANOGRAM_DELETING });
        const user = getState().user;

        return deletePlanogramHTTPRequest(deviceCode, user.group.Id)
            .then(response => dispatch({ type: PLANOGRAM_DELETED }))
            .catch(error => dispatch({ type: PLANOGRAM_ERROR, error }));
    };
};
